// this will account for stringified versions of keys
export const isConfigKeyGenericChannelId = configKey => {
  if (!configKey) return false;
  const parsedKey = parseInt(configKey.toString(), 10);
  return !isNaN(parsedKey);
};